module.exports = __webpack_public_path__ + "media/assets/images/icons/binnacle-icon2-016fb7d6a1176e9f4033fe0796382079.svg";